import {notification} from 'antd'

import {
    updateDailyExchangeRates,
    updateAnnualExchangeRates,
    updateSDRExchangeRate,
    updateExchangeRatesNonEU
} from "../api/api";

export const updateDailyRates = async()=> {
    const {data} = await updateDailyExchangeRates()
    if(data == 200){

          notification['success']({
            message: 'Daily Exchange Rates Synced',
            description:
              'Daily exchange rates have been successfully syned with ECB',
            duration: 3,
          });
    }
    else{

          notification['error']({
            message: 'Unsuccessful!',
            description:
              'Daily exchange rates have not been retrieved from ECB. For the time being, system may use the previously updated rates. Contact technical services',
            duration: 0,

          });

    }
}

export const updateAnnualRates = async()=> {
    const {data} = await updateAnnualExchangeRates()
    if(data == 200){

          notification['success']({
            message: 'Annual Exchange Rates Synced',
            description:
              'Annual exchange rates have been successfully syned with ECB',
            duration: 3,
          });
    }
    else{

          notification['error']({
            message: 'Unsuccessful!',
            description:
              'Annual exchange rates have not been retrieved from ECB. For the time being, system may use the previously updated rates. Contact technical services',
            duration: 0,

          });

    }
}

export const updateSDRRate = async()=> {
    const {data} = await updateSDRExchangeRate();
    if(data === 200){
        notification['success']({
            message: 'SDR Exchange Rates Synced',
            description:
                'SDR exchange rates have been successfully syned with IMF',
            duration: 3,
        });
    } else {
        notification['error']({
            message: 'Unsuccessful!',
            description:
                'SDR exchange rates have not been retrieved from IMF. For the time being, system may use the previously updated rates. Contact technical services',
            duration: 0,
        });
    }
};


export const updateNonEUExchangeRates = async(country)=> {
    const {data} = await updateExchangeRatesNonEU({country})
    if(data === 200){

        notification['success']({
            message: 'Exchange Rates Synced',
            description:
                'Exchange rates have been successfully synced for '+country,
            duration: 3,
        });
    }
    else{

        notification['error']({
            message: 'Unsuccessful!',
            description:
                'Exchange rates have not been retrieved. For the time being, system may use the previously updated rates. Contact technical services',
            duration: 0,

        });

    }
}

